import { SpecialIntegrationKeysObjectType } from '@app/interfaces/settings.type';
import { Button, Input } from '@ui';
import React, { FC } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import useTranslation from '@app/hooks/use-translation';
import { formBaseButtonBlockStyles } from '@app/styles/base-styles';
import { useMutateSpecialIntegrationKeysMutation } from '@app/store/api/intergation-settings.api';

type FormType = SpecialIntegrationKeysObjectType;
type SpecialIntegrationFormPropsType = { defaultValues: FormType | undefined; onClose(): void };

const labelClassName = 'text-0color font-medium text-[15px]';
const fieldBlockClassName = 'grid grid-cols-[120px_1fr]';

const SpecialIntegrationForm: FC<SpecialIntegrationFormPropsType> = (props) => {
  const { t } = useTranslation('common.forms');
  const { t: integ_t } = useTranslation('pages.settings.integrations.special_integration');
  const [mutateIntegration] = useMutateSpecialIntegrationKeysMutation();

  const { defaultValues, onClose } = props;
  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
  } = useForm<FormType>({
    defaultValues: defaultValues || {
      afields: [
        { description: '', value: '', key: '' },
        { description: '', value: '', key: '' },
        { description: '', value: '', key: '' },
        { description: '', value: '', key: '' },
      ],
    },
  });
  const { fields } = useFieldArray({ control, name: 'afields' });

  function onSubmit(data: FormType) {
    mutateIntegration(data)
      .unwrap()
      .finally(() => onClose());
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="relative">
        {fields.map((field, index) => (
          <div className="flex flex-col gap-[10px] " key={field.id}>
            <div className="flex items-center gap-[20px]">
              <div className="flex flex-col gap-[20px] grow ">
                <div className={fieldBlockClassName}>
                  <span className={labelClassName}>{integ_t('key_label')}</span>
                  <Input
                    {...register(`afields.${index}.key`, {
                      required: { value: true, message: t('required') },
                      maxLength: { value: 256, message: t('max_len_error', { num: 256 }) },
                    })}
                    error={errors?.afields?.[index]?.key?.message}
                  />
                </div>
                <div className={fieldBlockClassName}>
                  <span className={labelClassName}>{integ_t('value_label')}</span>
                  <Input
                    {...register(`afields.${index}.value`, {
                      required: { value: true, message: t('required') },
                      maxLength: { value: 256, message: t('max_len_error', { num: 256 }) },
                    })}
                    error={errors?.afields?.[index]?.value?.message}
                  />
                </div>
                <div className={fieldBlockClassName}>
                  <span className={labelClassName}>{integ_t('description_label')}</span>
                  <Input
                    {...register(`afields.${index}.description`, {
                      required: { value: true, message: t('required') },
                      maxLength: { value: 256, message: t('max_len_error', { num: 256 }) },
                    })}
                    error={errors?.afields?.[index]?.description?.message}
                  />
                </div>
              </div>
            </div>
            {index !== fields.length - 1 && (
              <div className="w-full border-[1px] border-b_dark mb-[20px] mt-[10px]" />
            )}
          </div>
        ))}
        <div className={formBaseButtonBlockStyles + ' pb-[20px]'}>
          <Button type="submit" label={integ_t('save')} />
          <Button onClick={onClose} label={integ_t('cancel')} fill="linked" />
        </div>
      </div>
    </form>
  );
};

export default SpecialIntegrationForm;
